import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import './PageLayout.scss'
import { isUserStaff, isUserAdmin } from '../../lib/helpers'
import { BeatLoader } from 'react-spinners'

class PageLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    user: PropTypes.any,
    router: PropTypes.shape({}),
    logout: PropTypes.func,
    getUser: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount () {
    const { getUser } = this.props

    // getUser() is async (dispatches an API call); a 401/expired-token
    // response is handled globally by the axios interceptor in store/user.js,
    // which redirects to /login. Here we just always stop the spinner.
    getUser()
      .catch(() => {})
      .then(() => {
        this.setState({ loading: false })
      })
  }

  logout = () => {
    const { logout, router } = this.props
    logout()
    router.push('/login')
  }

  render () {
    const { user, children } = this.props

    const isStaff = isUserStaff(user)
    const isAdmin = isUserAdmin(user)

    return (
      <div>
        <nav className='navbar navbar-expand-lg navbar-light bg-light'>
          <Link className='navbar-brand' to={'/'}>Athelas Dashboard</Link>
          <button
            className='navbar-toggler'
            type='button'
            data-toggle='collapse'
            data-target='#navbarSupportedContent'
            aria-controls='navbarSupportedContent'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon' />
          </button>
          <div className='collapse navbar-collapse' id='navbarSupportedContent'>
            <ul className='navbar-nav nav' style={{ width: '100%' }}>
              { isStaff
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/versions'}>
                    Version Management
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/qc/list'}>
                    QCs
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/client-versions'}>
                    Client Versions
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/claims'}>
                    Claims
                  </Link>
                </div>
              </li> : ''}
              { isAdmin
              ? <li className='nav-item'>
                <div style={{ cursor: 'pointer' }}>
                  <Link className='nav-link' to={'/concierge'}>
                    Concierge
                  </Link>
                </div>
              </li> : ''}
              <li className='nav-item' style={{ marginLeft: 'auto' }}>
                <div className='nav-link' onClick={this.logout} style={{ cursor: 'pointer' }}>
                  Logout
                </div>
              </li>
            </ul>
          </div>

        </nav>
        <div className='container-fluid text-center'>
          { this.state.loading ? <BeatLoader /> : (
            <div className='page-layout__viewport'>
              {children}
            </div>
            )
          }
        </div>
      </div>
    )
  }
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js